export const ensureArray = <T>(value?: T | T[]): T[] => {
  if (Array.isArray(value)) {
    return value;
  } else if (value === undefined || value === null) {
    return [];
  } else {
    return [value];
  }
};
